import ShopPaymentResourceListResultModel from '../../generated/types/model/resource/ShopPaymentResourceListResultModel';

export default class ShopPaymentResourceListResultViewModel extends ShopPaymentResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
